import elementIsVisibile from './dom/element-visibility';
import { addClass, removeClass } from './dom/className';
import onDelay from './dom/on-delay';



export const slideVideoWrapper = (
  videos,
  videoSlideElements,
  slideVideoElements,
  {
    states: {
      visible,
      invisible
    },
    classes: {
      slideVideoActiveClass
    }
  }
) => ({
  activeIndex: 0,
  isPlaying: false,
  playingPromise: null,
  freezed: [], // video indexes for which autoplay should not start without user interaction
  currentState (currentSlideIndex) {
    if (!videoSlideElements || !videoSlideElements.length) {
      return false;
    }

    const index = this.activeIndex;
    const videoElement = slideVideoElements[index];
    const video = videos[index];

    if (!video || !videoElement) {
      return false;
    }

    if (currentSlideIndex !== index) {
      return false;
    }

    if (!elementIsVisibile(videoElement, 2 / 3)) {
      return invisible;
    }

    return visible;
  },
  play (index = null, time = null) {
    if (!videoSlideElements || !videoSlideElements.length) {
      return;
    }

    if (index === null) {
      index = this.activeIndex;
    }

    if (index !== this.activeIndex) {
      if (this.isPlaying) {
        this.pause(); // pause previous video slide
      }

      this.activeIndex = index;
    }

    if (this.freezed.includes(this.activeIndex)) {
      return;
    }

    const slide = videoSlideElements[index];
    const videoElement = slideVideoElements[index];

    if (!this.isPlaying) {
      this.playingPromise = videoElement.play();
      this.isPlaying = true;
      addClass(slide, slideVideoActiveClass);
    }

    if (time !== null) {
      videoElement.currentTime = time;
    }
  },
  pause (time = null) {
    if (!videoSlideElements || !videoSlideElements.length) {
      return 0;
    }
    const index = this.activeIndex;

    removeClass(videoSlideElements[index], slideVideoActiveClass);

    const videoElement = slideVideoElements[index];

    if (this.playingPromise) {
      this.playingPromise.then(() => videoElement.pause());
      this.isPlaying = false;
      videoElement.muted = true;
    }

    if (time !== null) {
      videoElement.currentTime = time;
    }

    return videoElement.currentTime;
  },
  freeze (time = null) {
    this.freezed.push(this.activeIndex);
    return this.pause(time);
  },
  unfreeze (index = null) {
    this.freezed = this.freezed.filter((freezedVideoIndex) => freezedVideoIndex !== (index || this.activeIndex));
  },
  isFreezed (index) {
    return this.freezed.includes(index);
  }
});

export const videoPopupWrapper = (
  slideVideo,
  popupElement,
  videoPopupElements,
  videoPopupVideoElements,
  {
    withControls,
    classes: {
      videoPopupControlsActiveClass,
      videoPopupActiveClass,
      videoPopupPlayingClass
    },
    locations: {
      root,
      fullscreenVideoActive
    }
  }
) => ({
  openedIndex: null,
  playing: false,
  isActive: false,
  playingPromise: null,
  effectOff: () => {
  },
  activateControls () {
    if (this.openedIndex === null) {
      return;
    }
    this.effectOff();
    addClass(videoPopupElements[this.openedIndex], videoPopupControlsActiveClass);

    this.effectOff = onDelay(() => this.deactivateControls(), 3000);
  },
  deactivateControls () {
    if (this.openedIndex === null) {
      return;
    }
    this.effectOff();
    removeClass(videoPopupElements[this.openedIndex], videoPopupControlsActiveClass);
  },
  activate (index) {
    this.isActive = true;
    this.openedIndex = index;

    popupElement.activate();
    addClass(videoPopupElements[index], videoPopupActiveClass);
    slideVideo.unfreeze();
    this.play(slideVideo.pause());
    window.location.hash = fullscreenVideoActive;

    if (withControls) {
      this.activateControls();
    }
  },
  deactivate ({
    resetAndPause = false
  } = {}) {
    this.isActive = false;

    if (this.openedIndex === null) {
      return;
    }

    if (withControls) {
      this.deactivateControls();
    }

    const index = this.openedIndex;

    popupElement.deactivate();
    removeClass(videoPopupElements[index], videoPopupActiveClass);

    const isPlaying = this.playing;
    const timePaused = this.pause();

    if (resetAndPause) {
      slideVideo.freeze(0);
    } else if (isPlaying) {
      slideVideo.play(index, timePaused);
    } else {
      slideVideo.freeze(timePaused);
    }
    window.location.hash = root;
  },
  pause () {
    if (this.openedIndex === null) {
      return 0;
    }
    const index = this.openedIndex;

    const videoElement = videoPopupVideoElements[index];

    if (this.playingPromise) {
      this.playingPromise.then(() => videoElement.pause());
      this.playing = false;
    }

    if (videoElement.currentTime === videoElement.duration) {
      videoElement.currentTime = 0;
    }
    removeClass(videoPopupElements[index], videoPopupPlayingClass);

    return videoElement.currentTime;
  },
  play (currentTime = null) {
    if (this.openedIndex === null) {
      return;
    }
    const index = this.openedIndex;
    const videoElement = videoPopupVideoElements[index];

    if (currentTime !== null) {
      videoElement.currentTime = currentTime;
    }

    if (!this.playing) {
      this.playingPromise = videoElement.play();
      this.playing = true;
      addClass(videoPopupElements[index], videoPopupPlayingClass);
    }
  },
  togglePlay () {
    if (!this.playing) {
      this.play();
    } else {
      this.pause();
    }
  }
});



// WEBPACK FOOTER //
// ./src/lib/video-api-wrapper.js